<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_v"></a><a id="page_vi"><span class="txit">This novel is for all those in the military, law enforcement, and Intelligence Community who toil against the endless threats our country faces. Your perseverance, dedication, and sacrifice keep us safe and preserve our way of life in these dark times. Never yield to those who wish to do us harm and replace liberty with totalitarianism and fear. Your fight is a good and just one. Semper Fi.</span></a></p><a id="page_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?3d17f891